<template>
    <v-container>
        <form-toolbar :canEdit="canEdit" :userRoles="userRoles" :editMode="editMode"  :field="'welding'" :assignment="assignment" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class="first-row">
                    <custom-datetime :value="localWelding.appointmentDate || ''" :readOnly="true" @onSelect="appointmentDateSelected"/>
                    <v-select
                        v-model="localWelding.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                    ></v-select>
                    <!-- <div class="precommitment">
                        <v-file-input
                            v-if="editMode"
                            v-model="precommitmentToUpload"
                            :rules="editMode ? rules: []"
                            accept="application/pdf, text/csv, .csv, text/plain, application/msword, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            :placeholder="localWelding.precommitmentFileUrl ? 'Αλλαγή Αρχείου Προδέσμευσης' : 'Ανέβασμα Αρχείου Προδέσμευσης'"
                            prepend-icon="mdi-file-multiple"
                            :clearable="clearable"
                            :label="localWelding.precommitmentFileUrl ? 'Αλλαγή Αρχείου Προδέσμευσης' : 'Ανέβασμα Αρχείου Προδέσμευσης'"
                            class="field precommitment"
                            :disabled="readOnly"
                        ></v-file-input>
                        <v-btn v-if="localWelding.precommitmentFileUrl" class="mx-2 white--text" large color="black" @click="downloadPrecommitmentFile">
                            ΠΡΟΔΕΣΜΕΥΣΗ
                        </v-btn>
                    </div> -->
                    <v-dialog
                        v-if="this.assignment?.autopsy?.floorStructure"
                        v-model="dialog"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text"
                                large
                                :color="'black'"
                                :depressed="editMode">
                                Δομη Κτιριου
                            </v-btn>
                        </template>
                        <floor-structure :editMode="false" :stored="this.assignment.autopsy.floorStructure" />
                    </v-dialog>
                </div>
                <comments
                    ref="comments"
                    :comments="this.localWelding?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode ? rules: []"
                    @new-comment="onNewComment"
                />
                <material-selection v-if="config.hasStorage" ref="material-selection" :editMode="editMode" :assignmentTab="'welding'" :assignment="assignment" />
                <image-section ref="image-section" :uploadedPhotos="this.localWelding.photos || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :uploadPath="this.assignment.sr + '/welding'" @photoSelection="onPhotoSelection" :title="'Φωτογραφίες'" :zipName="this.assignment.sr + '_' + 'welding'"/>
                <v-divider class="mt-5"/>
                <!-- <file-section ref="file-section" :label="'Ανέβασμα αρχείων OTDR'" :alreadyUploadedFiles="this.localWelding.measurementFiles || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :folderPath="this.assignment.sr + '/measurement'"/> -->
                <issue-existance-field
                    ref="prodesmeusi-difference-section"
                    :label="'Διαφορά από Προδέσμευση'"
                    :check="hasProdesmeusiDifference"
                    :comments="localWelding.prodesmeusiDifference?.comments || {}"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    noImages
                />
                <v-divider />
                <issue-existance-field
                    ref="malfunction-section"
                    :label="'Βλάβη / Πρόβλημα'"
                    :photoLabel="'Φωτογραφίες Βλάβης'"
                    :check="hasMalfunction"
                    :comments="localWelding.malfunction?.comments || {}"
                    :uploadedPhotos="localWelding.malfunction?.photos || []"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    :uploadPath="this.assignment.sr + '/welding/malfunction'"
                    @onIssuePhotoSelection="onTroublePhotoSelection"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import ImageSection from '@/components/ImageSection'
    // import FileSection from '@/components/FileSection'
    import FormToolbar from '@/components/FormToolbar'
    import geolocation from '@/utils/geolocation'
    import MaterialSelection from '@/components/MaterialSelection'
    import FloorStructure from '@/components/FloorStructure'
    // import uploadService from '@/services/upload'
    // import file from '@/utils/file'
    import Comments from '@/components/Comments'
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'
    import IssueExistanceField from '@/components/IssueExistanceField'

    export default {
        name: 'WendingTab',
        components: { Alert, IssueExistanceField, Comments, ImageSection, CustomDatetime, FormToolbar, MaterialSelection, FloorStructure },
        watch: {
            assignment: {
                handler(newVal, oldVal) {
                    this.resetForm()
                },
                deep: true
            }
        },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                if (this.localWelding.status === 'FOR_CANCELLING') {
                    return false
                }
                return !((this.localWelding.comments || this.newComment) && this.localWelding.appointmentDate && this.editMode)
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.welding?.statuses || []
            }
        },
        data: () => {
            return {
                localWelding: {
                    description: null,
                    photos: []
                },
                selectedTroublePhotos: 0,
                newComment: null,
                hasMalfunction: false,
                hasProdesmeusiDifference: false,
                // precommitmentToUpload: null,
                selectedPhotos: 0,
                showAlert: false,
                dialog: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                readOnly: false,
                clearable: true,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                editMode: false
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            appointmentDateSelected(datetime) {
                this.$set(this.localWelding, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            onTroublePhotoSelection(noOfSelectedPhotos) {
                this.selectedTroublePhotos = noOfSelectedPhotos
            },
            // downloadPrecommitmentFile() {
            //     if (!this.localWelding.precommitmentFileUrl) {
            //         return
            //     }
            //     file.downloadFile(process.env.VUE_APP_HETZNER_API_STORAGE_URL + '/' + this.localWelding.precommitmentFileUrl)
            // },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            onPhotoSelection(selectedPhotos) {
                this.selectedPhotos = selectedPhotos.length
            },
            resetForm() {
                this.localWelding = this.assignment.welding ? { ...this.assignment.welding } : {}
                this.hasMalfunction = !!this.localWelding.malfunction
                this.hasProdesmeusiDifference = !!this.localWelding.prodesmeusiDifference
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            // async uploadPrecommitmentFile() {
            //     if (!this.precommitmentToUpload) {
            //         return ''
            //     }
            //     let formData = new FormData()
            //     formData.append('file', this.precommitmentToUpload)
            //     try {
            //         const response = await uploadService.uploadFile(this.assignment.sr + '/measurement', formData)
            //         this.localWelding.precommitmentFileUrl = response.data.content
            //     } catch (e) {
            //         this.setAlert(e.response.data.message, 'error')
            //         this.loading = false
            //         throw new Error(e.response.data.message)
            //     }
            //     this.precommitmentToUpload = null
            // },
            async editAssignment() {
                this.loading = true
                if (!this.localWelding.measurementFiles) {
                    this.localWelding.measurementFiles = []
                }
                const coords = await geolocation.getCoordinates()

                // await this.uploadPrecommitmentFile()
                // try {
                //     const uploadedFiles = await this.$refs['file-section'].uploadSelectedFiles()
                //     this.localWelding.measurementFiles = uploadedFiles ? this.localWelding.measurementFiles.concat(uploadedFiles) : [ ...this.localWelding.measurementFiles ]
                // } catch (error) {
                //     this.setAlert(error.message, 'error')
                //     this.loading = false
                //     return
                // }
                const malfunctionSection = this.$refs['malfunction-section'].getIssueValues()
                this.hasMalfunction = malfunctionSection.checked
                if (this.hasMalfunction) {
                    this.localWelding.malfunction = this.localWelding.malfunction || { photos: [] }
                    this.localWelding.malfunction.newComment = malfunctionSection.newComment
                }
                if (!this.localWelding.photos) {
                    this.localWelding.photos = []
                }
                try {
                    const uploadedPhotos = await this.$refs['image-section'].uploadPhotos()
                    this.localWelding.photos = uploadedPhotos ? this.localWelding.photos.concat(uploadedPhotos) : [ ...this.localWelding.photos ]
                    if (this.hasMalfunction) {
                        const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                        this.localWelding.malfunction.photos = uploadedTroubleshootingPhotos ? this.localWelding.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localWelding.malfunction.photos ]
                    }
                } catch (error) {
                    this.setAlert(error.message, 'error')
                    this.loading = false
                    return
                }

                const prodesmeusiDifferenceSection = this.$refs['prodesmeusi-difference-section'].getIssueValues()
                this.hasProdesmeusiDifference = prodesmeusiDifferenceSection.checked
                if (this.hasProdesmeusiDifference) {
                    this.localWelding.prodesmeusiDifference = this.localWelding.prodesmeusiDifference || {}
                    this.localWelding.prodesmeusiDifference.newComment = prodesmeusiDifferenceSection.newComment
                }
                this.localWelding.geolocation = coords
                this.localWelding.newComment = this.newComment
                if (this.config.hasStorage) {
                    this.localWelding.materialsRequested = this.$refs['material-selection'].proccessMaterialRequested()
                }
                assignmentService.updateAssignmentTab('welding', this.assignment.id, { welding: this.localWelding }).then((response) => {
                    this.loading = false
                    this.setAlert('Η ενημέρωση της κόλλησης ήταν επιτυχημένη', 'success')
                    this.$refs['comments'].clear()
                    this.$refs['malfunction-section'].clear()
                    this.$refs['prodesmeusi-difference-section'].clear()
                    this.switchEditMode(false)
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.appointment-datetime {
    min-width: 200px;
    max-width: 20%;
}
.first-row {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-items: first baseline;
    margin-top: 0.8rem;
}
.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.edit-button-wrapper {
    display: flex;
    justify-content: flex-start;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.field.completed-checkbox {
    font-weight: 800;
}
.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

</style>
